import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTaskCalendarDateRange } from "../data/queries/taskQueries";
import moment from "moment";
import Enums from "../types/enums";
import { useBoardProvider } from "../contexts/board/boardContext";

export const useCalendarTasks = (selectedDate, onTaskClick) => {
  const { t } = useTranslation(["RightPanel"]);
  const { currentBoardId } = useBoardProvider();
  const [pendingTasks, setPendingTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);

  const from = moment(selectedDate)
    .startOf("day")
    .add(2, "minute")
    .toISOString();
  const to = moment(selectedDate).endOf("day").toISOString();

  const { data: tasks } = useTaskCalendarDateRange(currentBoardId, from, to);

  const mapTaskToCalendarDetail = (task) => {
    return {
      title: task?.Name,
      subtitle: task?.Client?.FullName,
      taskType: `${task?.TaskType?.Title || "Unknown Type"} • ${task.Number}`,
      date: moment.utc(task?.DueDate).toDate(),
      text: t(task.Stage.Title),
      color: task?.Stage?.Color,
      overdue:
        task.Stage?.StageType !== Enums.StageType.Completed &&
        moment
          .utc(task.DueDate)
          .endOf("day")
          .diff(moment.utc().endOf("day"), "days") <= 0,
      onClick: () => {
        onTaskClick(task?.Id);
      },
    };
  };

  useEffect(() => {
    if (tasks) {
      const pending = tasks
        ?.filter((task) => task?.Stage?.StageType !== Enums.StageType.Completed)
        .map(mapTaskToCalendarDetail);

      const completed = tasks
        ?.filter((task) => task?.Stage?.StageType === Enums.StageType.Completed)
        .map(mapTaskToCalendarDetail);

      setPendingTasks(pending);
      setCompletedTasks(completed);
    }
  }, [tasks, t]);

  return { pendingTasks, completedTasks };
};
